<template>
  <div class="footerCommon" :class="{noFooter : !this.IsShowFooter}">
    <div class="footer" v-show="IsShowFooter">
      <div class="footer-box">
        <div class="box_left">
          <div class="footer-box-top">
            <div class="footer-top-div">
              <div class="footer-top-con clearfix cp" @click="goConsult">
                <div class="footer-con-img">
                  <img
                    class="footer-img-detail"
                    src="../../assets/img/index/icon_footer_phone.svg"
                    alt="需求咨询"
                  />
                </div>
                <h1 class="footer-con-title">需求咨询</h1>
              </div>
            </div>
            <div class="footer-top-div">
              <div class="footer-top-con clearfix cp" @click="goMore('footer-yuyueyanshi')">
                <div class="footer-con-img">
                  <img
                    class="footer-img-detail"
                    src="../../assets/img/index/icon_footer_demonstrate.svg"
                    alt="预约演示"
                  />
                </div>
                <h1 class="footer-con-title">预约演示</h1>
              </div>
            </div>
            <a class="footer-top-div" :href="goHelp()">
              <div class="footer-top-con clearfix cp">
                <div class="footer-con-img">
                  <img
                    class="footer-img-detail"
                    src="../../assets/img/index/icon_footer_help.svg"
                    alt="支持帮助"
                  />
                </div>
                <h1 class="footer-con-title">支持帮助</h1>
              </div>
            </a>
            <a class="footer-top-div" :href="goDown()">
              <div class="footer-top-con clearfix cp">
                <div class="footer-con-img">
                  <img
                    class="footer-img-detail"
                    src="../../assets/img/index/icon_download.svg"
                    alt="资料下载"
                  />
                </div>
                <h1 class="footer-con-title">资料下载</h1>
              </div>
            </a>
          </div>
          <div class="footer-box-bottom">
            <div>
              <h2 class="title">{{footer[0].name}}</h2>
              <div class="detail">
                <div class="detail-left">
                  <div
                    class="detail-msg"
                    v-for="(item,index) in footer[0].s.slice(0,7)"
                    :key="index"
                  >
                    <!--<span v-show="item.status === '1'" class="msg-content" @click="goRooter(item.name, item.link)" >{{item.name}}</span>-->
                    <a
                      v-show="item.status === '1'"
                      class="msg-content"
                      :href="getRooterLink(item.name, item.link)"
                    >{{item.name}}</a>
                  </div>
                </div>
                <div class="detail-right">
                  <div
                    class="detail-msg"
                    v-for="(item,index) in footer[0].s.slice(-5)"
                    :key="index"
                  >
                    <!--<span v-show="item.status === '1'" class="msg-content" @click="goRooter(item.name, item.link)" >{{item.name}}</span>-->
                    <a
                      v-show="item.status === '1'"
                      class="msg-content"
                      :href="getRooterLink(item.name, item.link)"
                    >{{item.name}}</a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2 class="title">{{footer[1].name}}</h2>
              <div class="detail">
                <div class="detail-left">
                  <div
                    class="detail-msg"
                    v-for="(item,index) in footer[1].s.slice(0,6)"
                    :key="index"
                  >
                    <!--<span v-show="item.status === '1'" class="msg-content" @click="goRooter(item.name, item.link)" >{{item.name}}</span>-->
                    <a
                      v-show="item.status === '1'"
                      class="msg-content"
                      :href="getRooterLink(item.name, item.link)"
                    >{{item.name}}</a>
                  </div>
                </div>
                <div class="detail-right">
                  <div
                    class="detail-msg"
                    v-for="(item,index) in footer[1].s.slice(-5)"
                    :key="index"
                  >
                    <!--<span v-show="item.status === '1'" class="msg-content" @click="goRooter(item.name, item.link)" >{{item.name}}</span>-->
                    <a
                      v-show="item.status === '1'"
                      class="msg-content"
                      :href="getRooterLink(item.name, item.link)"
                    >{{item.name}}</a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2 class="title">{{footer[2].name}}</h2>
              <div class="detail">
                <div class="detail-left">
                  <div class="detail-msg" v-for="(item,index) in footer[2].s" :key="index">
                    <span
                      v-show="item.status === '1'"
                      class="msg-content"
                      @click="goRooter(item.name, item.link)"
                    >{{item.name}}</span>
                    <!--<a v-show="item.status === '1'" class="msg-content" :href="getRooterLink(item.name, item.link)">{{item.name}}</a>-->
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2 class="title">{{footer[3].name}}</h2>
              <div class="detail">
                <div class="detail-left">
                  <div class="detail-msg" v-for="(item,index) in footer[3].s" :key="index">
                    <!--<span v-show="item.status === '1'" class="msg-content" @click="goRooter(item.name, item.link)" >{{item.name}}</span>-->
                    <a
                      v-show="item.status === '1'"
                      class="msg-content"
                      :href="getRooterLink(item.name, item.link)"
                    >{{item.name}}</a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="linkShow">
              <h2 class="title">友情连接</h2>
              <div class="detail">
                <div class="detail-left">
                  <div class="detail-msg" v-for="(item, index) in linkData" :key="index">
                    <a
                      class="msg-content"
                      :href="item.url"
                      rel="external nofollow"
                      target="_blank"
                    >{{item.name}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="right_msg">
            <div class="detail">
              <p class="footer-tel-p">
                客服电话：
                {{QRcode.mobile}}
              </p>
              <p class="footer-tel-p">
                商务合作：
                {{QRcode.email}}
              </p>
              <img v-lazy="$global.globalPath + QRcode.src" class="footer-img" :alt="QRcode.title" />
              <h2 class="detail-msg detail-text">{{QRcode.title}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="dib">Copyright © 2017.上海甄云信息科技有限公司</div>
      <div class="dib ml30 footer-a">
        <a class="dib ml30" href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备18039109号-4</a>
        <a
          class="dib ml30"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802002961"
          target="_blank"
        >
          <img src="../../assets/img/index/beian-icon.png" />沪公网安备31011802002961号
        </a>
        <a href="https://webcert.cnmstl.net/cert/grade?sn=2c1611bab21711ea9e3300163e068ceb" target="_blank" id="jvs-cert"></a>
        <div class="dib ml30">
          使用条款 客户隐私政策
          <span id="cnzz_stat_icon_1278721967"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['openRegister', 'goConsult'],
  data () {
    return {
      IsShowFooter: true,
      blackList: ['NotFound', 'ServiceUnavailable'],
      footer: this.$store.state.footer || [],
      QRcode: {},
      // loading: false,
      linkData: this.$store.state.friendList || [], // 友情连接
      linkShow: true
    }
  },
  methods: {
    goMore (code) {
      if (this.$route.params.code) {
        this.openRegister(false, this.$route.params.code + '-' + code)
      } else {
        this.openRegister(false, code)
      }
    },
    GoRouterFooter (ip) {
      if (ip === 'ip1') {
        window.open('http://www.beian.miit.gov.cn', '_blank')
      }
      if (ip === 'ip2') {
        window.open(
          'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802002961',
          '_blank'
        )
      }
    },
    // 帮助
    goHelp () {
      let routeUrl = this.$router.resolve({ path: '/servicesupport' })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    // 下载
    goDown () {
      let routeUrl = ''
      if (this.$route.meta.content !== 'SRM云') {
        routeUrl = this.$router.resolve({ path: '/datadownload' })
      } else {
        routeUrl = this.$router.resolve({
          path: '/datadownload/detail?list=6&item=16'
        })
      }
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    // 获取尾部导航标题
    getFooterDate () {
      this.$api.post('/base/footer_nav', '', r => {
        if (r.code === 0) {
          this.footer = r.data
          // this.loading = true
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取二维码
    getQRcode () {
      this.$api.post('/base/QR_code', '', r => {
        if (r.code === 0) {
          this.QRcode = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    goRooter (el, value) {
      if (el === '产品演示') {
        if (this.$route.params.code) {
          this.openRegister(
            false,
            `${this.$route.params.code}-footer-chanpinyanshi`
          )
        } else {
          this.openRegister(false, 'footer-chanpinyanshi')
        }
      } else if (el === '需求咨询') {
        this.goConsult()
      } else if (el === '常见问题') {
        this.$router.push({
          name: 'ServiceSupport',
          params: {
            IsShow: true
          }
        })
      } else {
        this.$router.push({ path: value })
      }
    },
    getRooterLink (el, value) {
      if (el === ('产品演示' || '需求咨询' || '常见问题')) {
        return 'javascript:void(0)'
      } else {
        let routeUrl = this.$router.resolve({ path: value })
        let result = this.$global.frontPath + routeUrl.href
        return result
      }
    },
    checkFooter (name) {
      var routeName = name

      function isBlackList (str) {
        return str === routeName
      }

      let result = this.blackList.findIndex(isBlackList)
      if (result >= 0) {
        this.IsShowFooter = false
      } else {
        this.IsShowFooter = true
      }
    },
    // 友情链接
    getLinkData () {
      this.$api.post('/base/friend_site_list', '', r => {
        if (r.code === 0) {
          this.linkData = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    }
  },
  created () {},
  watch: {
    $route (next) {
      if (next.name === 'Index') {
        this.linkShow = true
      } else {
        this.linkShow = false
      }
    }
  },
  mounted () {
    this.checkFooter(this.$route.name)
    if (!this.footer.length) {
      this.getFooterDate()
    }
    this.getQRcode()
    if (!this.linkData.length) {
      this.getLinkData()
    }
  },
  activated () {},
  components: {}
}
</script>
<style scoped lang="scss">
.noFooter {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.footerCommon {
  min-width: 1200px;
  background-color: #242a37;

  .footer-copyright {
    font-size: 14px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #242a37;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer-a {
      display: flex;
      align-items: center;
      justify-content: center;

      #jvs-cert {
        display: block;
        max-width: 92px;
        margin-left: 30px;
        width: 50px;
        height: 50px;
        padding: 15px 0;
      }
    }

    .ml30 {
      margin-left: 30px;
    }

    a {
      font-size: 14px;
      text-align: center;
      line-height: 50px;
      background: #242a37;
      color: #999;

      img {
        border: none;
        vertical-align: text-top;
        width: 15px;
        margin-right: 2px;
      }
    }
  }

  .footer {
    width: 100%;
    height: 495px;
  }

  .footer-box {
    width: 1200px;
    //  height: 620px;
    margin: 0 auto;

    .box_left,
    .box_right {
      float: left;
    }

    .box_left {
      width: 850px;
    }

    .box_right {
      width: 350px;

      .detail {
        margin-top: 53px;
      }
    }
  }

  .footer-box-top {
    width: 100%;
    height: 94px;
    margin: 0 auto;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
  }

  .footer-top-div {
    height: 100%;
    float: left;
  }

  .footer-top-con {
    margin-top: 53px;
  }

  .footer-con-img {
    float: left;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    position: relative;

    .footer-img-detail {
      width: 16.7px;
      height: 16.7px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .footer-con-title {
    float: left;
    margin-left: 16px;
    margin-top: 8px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .footer-con-title:hover {
    cursor: pointer;
  }

  /* 详细信息 */
  .footer-box-bottom {
    text-align: left;
    height: 345px;
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #fff;
    /*cursor: pointer;*/
  }

  .detail {
    margin-top: 25px;
    width: 100%;
    height: 280px;
  }

  .detail-left,
  .detail-right {
    width: 72px;
    float: left;
  }

  .detail-msg {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #999999;
    line-height: 36px;
  }

  .msg-content {
    color: #999999;
  }

  .msg-content:hover {
    color: #4cbace;
    cursor: pointer;
  }

  .footer-tel-p {
    font-size: 12px;
    line-height: 17px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(80, 188, 206, 1);
    text-align: left;
    margin: 10px 0 0 90px;
  }

  .footer-tel-p:nth-child(2) {
    line-height: 17px;
    margin-top: 8px;
    color: #fff;
  }

  .footer-img {
    width: 145px;
    height: 145px;
    margin-left: 90px;
    margin-top: 50px;
  }

  .detail-text {
    margin-left: 90px;
    line-height: 24px;
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
  }

  .footer-link {
    font-size: 12px;
    height: 30px;
    width: 1200px;
    margin: 0 auto;
    color: #ccc;

    .footer-a {
      margin: 0 20px;

      a {
        color: #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// footer.vue?756c0127